var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5735 32.6396H65.7246V55.9219H68.5735C74.619 55.8694 79.4886 50.6703 79.4886 44.2808C79.4886 37.8913 74.6025 32.6922 68.5735 32.6396Z",
    fill: "#00C880"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0928 32.6396C6.0473 32.6922 1.17773 37.8913 1.17773 44.2808C1.17773 50.6703 6.06386 55.8694 12.0928 55.9219H14.9417V32.6396H12.0928Z",
    fill: "#00C880"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M65.0287 64.4999H63.7533C63.5546 65.0951 63.3393 65.6903 63.0908 66.2505H64.8962C65.1281 65.6728 65.3268 65.0776 65.509 64.4824C65.3434 64.4999 65.1943 64.4999 65.0287 64.4999Z",
    fill: "#192C62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M73.0949 32.7626V20.0186C73.0949 9.25273 64.7968 0.5 54.6104 0.5H26.155C15.9189 0.5 7.5711 9.30525 7.5711 20.1236V32.7626C3.33094 34.6707 0.333008 39.1346 0.333008 44.2812C0.333008 51.1258 5.60009 56.7451 12.0928 56.7976H14.1135V57.4453C14.1135 70.1543 23.9024 80.5 35.9272 80.5H44.7388C53.8154 80.5 61.6167 74.6007 64.8962 66.2505H63.0908C59.9106 73.6204 52.8879 78.7495 44.7388 78.7495H35.9272C24.8133 78.7495 15.7699 69.1915 15.7699 57.4453V32.64C15.7699 32.1499 15.4055 31.7648 14.9417 31.7648H12.0763C11.0991 31.7823 10.155 31.9223 9.22742 32.1849V20.1236C9.22742 10.2681 16.8299 2.25055 26.155 2.25055H54.6104C63.8858 2.25055 71.4386 10.2155 71.4386 20.0186V32.1849C70.5276 31.9223 69.567 31.7823 68.5897 31.7648H65.7243C65.2771 31.7648 64.8962 32.1499 64.8962 32.64V57.4453C64.8962 59.9136 64.4986 62.2943 63.7533 64.5H65.0287C65.1943 64.5 65.3434 64.5 65.509 64.4825C66.1881 62.2593 66.5525 59.8961 66.5525 57.4453V56.7976H68.5897C69.567 56.7976 70.5276 56.6576 71.4386 56.395C72.0183 56.2549 72.5649 56.0449 73.0949 55.7998C77.3351 53.9092 80.333 49.4453 80.333 44.2812C80.333 39.1171 77.3351 34.6707 73.0949 32.7626ZM12.0928 33.5153H14.1135V55.047H12.0928C6.52763 55.012 1.98932 50.1805 1.98932 44.2812C1.98932 38.3818 6.52763 33.5678 12.0928 33.5153ZM68.5732 55.047H66.5525V33.5153H68.5732C74.1384 33.5678 78.6767 38.3993 78.6767 44.2812C78.6767 50.163 74.1384 55.012 68.5732 55.047Z",
    fill: "#192C62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M73.0949 55.7998V57.7254C73.0949 62.4169 69.4676 66.2506 65.0287 66.2506H40.333C39.8693 66.2506 39.5049 65.8479 39.5049 65.3753C39.5049 64.9027 39.8693 64.5 40.333 64.5H65.0287C65.1943 64.5 65.3434 64.5 65.509 64.4825C68.8051 64.2199 71.4386 61.279 71.4386 57.7254V56.395C72.0183 56.2549 72.5649 56.0449 73.0949 55.7998Z",
    fill: "#1696E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M53.9973 7.09961H26.6681C19.7448 7.09961 14.1133 13.0515 14.1133 20.3688V29.6642C14.1133 30.1543 14.4777 30.5394 14.9414 30.5394H18.8835C23.339 30.5394 27.1816 27.651 28.8048 23.5548C30.428 27.651 34.2706 30.5394 38.7261 30.5394H65.7406C66.2044 30.5394 66.5688 30.1543 66.5688 29.6642V20.3688C66.5688 13.0515 60.9373 7.09961 54.0139 7.09961H53.9973Z",
    fill: "#1696E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M42.9663 61.3838H37.6826C35.597 61.3838 33.9062 63.1707 33.9062 65.375C33.9062 67.5793 35.597 69.3663 37.6826 69.3663H42.9663C45.0519 69.3663 46.7427 67.5793 46.7427 65.375C46.7427 63.1707 45.0519 61.3838 42.9663 61.3838Z",
    fill: "#FFBA00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupport);
export default __webpack_public_path__ + "static/media/icon-support.1373bd95844bac8fca181895766a4fc4.svg";
export { ForwardRef as ReactComponent };